// extracted by mini-css-extract-plugin
export var avatarContainer = "_1e-0";
export var avatarTypingWave = "_1e-i";
export var gray = "_1e-f";
export var green = "_1e-c";
export var icon = "_1e-9";
export var image = "_1e-1";
export var lg = "_1e-6";
export var md = "_1e-5";
export var presenceDot = "_1e-b";
export var red = "_1e-d";
export var sm = "_1e-4";
export var status = "_1e-a";
export var typingDot = "_1e-h";
export var typingPill = "_1e-g";
export var xl = "_1e-7";
export var xs = "_1e-3";
export var xxl = "_1e-8";
export var xxs = "_1e-2";
export var yellow = "_1e-e";